/**
 * platform.js — Capacitor Plattform-Detection
 *
 * Zentrale Anlaufstelle für alle nativen Plattform-Checks.
 * Importiere immer aus diesem Modul statt direkt von @capacitor/core,
 * damit ein späterer Plattformwechsel nur hier angepasst werden muss.
 *
 * Verwendung:
 *   import { isNative, platform } from '@/services/platform'
 *   if (isNative) { ... }          // true auf iOS/Android, false im Browser
 *   if (platform === 'ios') { ... } // 'ios' | 'android' | 'web'
 */

import { Capacitor } from '@capacitor/core';

/**
 * true  → App läuft als native iOS-App (Capacitor-WebView)
 * false → App läuft im Browser (normaler Web-Betrieb)
 */
export const isNative = Capacitor.isNativePlatform();

/**
 * Aktuell aktive Plattform als String.
 * Mögliche Werte: 'ios' | 'android' | 'web'
 * Android ist aktuell nicht im Scope, aber der Check ist zukunftssicher.
 */
export const platform = Capacitor.getPlatform();
